(() => {
  if (customElements.get('hero-banner-slider')) {
    return;
  }

  class HeroBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      this.options = {
        slidesPerView: 1,
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        const autoplaySpeed = this.dataset.autoplaySpeed || 5000;
        this.options.autoplay = {
          delay: parseInt(autoplaySpeed, 10),
          disableOnInteraction: false,
        };
      }

      this.slider = new Swiper(sliderElement, this.options);
    }
  }

  customElements.define('hero-banner-slider', HeroBannerSlider);
})();

